module.exports = __webpack_public_path__ + "img/Gambella_Certificate.c8b521b4.jpg";